import Index from '@/views/index'
import jdyrole from '@/common/jdyrole'
export const userHome = {
  path: '/userHome',
  redirect: '/userHome/announcement',
  component: Index,
  name: 'userHome',
  meta: {
    requiresAuth: true
  },
  children: [
    {
      path: '/userHome/announcement',
      components: {
        default: () => import('@/views/userHome/announcement')
      },
      name: 'announcement',
      meta: {
        requiresAuth: true,
        title: '公告栏',
        requiresRole: [jdyrole.superadmin, jdyrole.productmanager]
      }
    }, {
      path: '/userHome/versionUpdate',
      components: {
        default: () => import('@/views/userHome/versionUpdate')
      },
      name: 'versionUpdate',
      meta: {
        requiresAuth: true,
        title: '版本更新栏',
        requiresRole: [jdyrole.superadmin, jdyrole.productmanager]
      }
    }
  ]
}



// WEBPACK FOOTER //
// ./src/router/userHome/index.js